// ============================================================================
// FILE: MaterialIssueListPage.js
// MODULE: PPE → Execution → Material Issue
//
// PURPOSE:
//   Displays operations waiting for material issue
//   Opens Material Issue Drawer
// ============================================================================

import React, { useEffect, useState } from "react";
import {
  getPendingMaterialIssues
} from "./materialIssueService";

import MaterialIssueDrawer from "./MaterialIssueDrawer";

const MaterialIssueListPage = () => {

  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [selectedOperation, setSelectedOperation] = useState(null);
  const [drawerOpen, setDrawerOpen] = useState(false);

  // --------------------------------------------------------------------------
  // Load pending material issues
  // --------------------------------------------------------------------------
  const loadData = async () => {
    try {
      setLoading(true);
      const res = await getPendingMaterialIssues();

      if (res.success) {
        setRows(res.data || []);
      }
    } catch (err) {
      console.error("Failed to load material issues", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
  }, []);

  // --------------------------------------------------------------------------
  // Open Drawer
  // --------------------------------------------------------------------------
  const handleIssueClick = (row) => {
    setSelectedOperation(row);
    setDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setDrawerOpen(false);
    setSelectedOperation(null);
    loadData(); // refresh after issue
  };

  // --------------------------------------------------------------------------
  // UI
  // --------------------------------------------------------------------------
  return (
    <div className="p-3">

      {/* ================= HEADER ================= */}
      <div className="mb-3">
        <h4 className="fw-bold">Material Issue Management</h4>
        <small className="text-muted">
          Issue reserved materials to shop floor
        </small>
      </div>

      {/* ================= SUMMARY CARDS ================= */}
      <div className="row mb-3">
        <div className="col-md-3">
          <div className="card shadow-sm p-3">
            <div className="text-muted">Pending Issues</div>
            <h5>{rows.length}</h5>
          </div>
        </div>
      </div>

      {/* ================= TABLE ================= */}
      <div className="card shadow-sm">
        <div className="card-body">

          {loading ? (
            <div>Loading...</div>
          ) : (
            <table className="table table-bordered table-hover">
              <thead className="table-light">
                <tr>
                  <th>Trigger ID</th>
                  <th>Production Plan</th>
                  <th>Operation</th>
                  <th>Status</th>
                  <th width="120">Action</th>
                </tr>
              </thead>
              <tbody>
                {rows.length === 0 && (
                  <tr>
                    <td colSpan="5" className="text-center">
                      No pending material issues
                    </td>
                  </tr>
                )}

                {rows.map((row) => (
                  <tr key={row.trigger_id}>
                    <td>{row.trigger_id}</td>
                    <td>{row.production_plan_id}</td>
                    <td>{row.plan_operation_id}</td>
                    <td>
                      <span className="badge bg-warning text-dark">
                        {row.status}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-primary"
                        onClick={() => handleIssueClick(row)}
                      >
                        Issue
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

          )}
        </div>
      </div>

      {/* ================= DRAWER ================= */}
      <MaterialIssueDrawer
        open={drawerOpen}
        operation={selectedOperation}
        onClose={handleDrawerClose}
      />

    </div>
  );
};

export default MaterialIssueListPage;